import { clientAxios } from '@/plugins/axios'
import format from 'string-format'

const baseURL = '/v1/order/subscription'
const getSubscriptionPatternFormLink = `${baseURL}/{id}/delivery-pattern/change`

export const getSubscriptions = (params) => clientAxios.get(`${baseURL}/`, { params })
export const getSubscriptionDetail = (id) => clientAxios.get(`${baseURL}/detail/${id}`)
export const updateSubscriptionPayment = (id, body) => clientAxios.patch(`${baseURL}/update/${id}/payment`, body)
export const updateSubscription = (id, body) => clientAxios.put(`${baseURL}/update/${id}`, body)

export const pauseSubscription = (id) =>
  clientAxios.patch(`${baseURL}/update/${id}/pause`, {
    customer_flag: true,
  })

export const cancelSubscription = (id, body) => clientAxios.patch(`${baseURL}/update/${id}/cancel`, body)
export const getDeliveryDateNext = ({ delivery_date, subscription_division_id, param1 = 0, param2 = 0, param3 = 0 }) =>
  clientAxios.post(`${baseURL}/delivery-date/next`, {
    delivery_date,
    subscription_division_id,
    param1,
    param2,
    param3,
  })

export const reopenSubscription = ({ id, is_update_subscription }) =>
  clientAxios.patch(`${baseURL}/update/${id}/reopen-scheduled`, {
    customer_flag: true,
    is_update_subscription,
  })

export const getLumpsumDeliverydate = (id) => clientAxios.get(`${baseURL}/${id}/delivery-date/list`)

export const getSubscriptionPatternForm = (id, body) =>
  clientAxios.post(format(getSubscriptionPatternFormLink, { id }), body)
